import React from "react";
import { InView } from 'react-intersection-observer';

const Vision = () => {
  return (
    <div className="bg-gray-900 py-20">
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Section - Content */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 text-left ${inView ? 'animate__animated animate__fadeInLeft' : 'opacity-0'}`}
            >
              <h2 className="text-4xl sm:text-5xl font-bold mb-8">
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Our Vision
                </span>
              </h2>
              <div className="space-y-6">
                <p className="text-gray-300 text-lg leading-relaxed">
                  Our vision is to become the world's most loved platform for ready-made marketing creatives, helping millions of businesses promote themselves through beautiful, AI-powered designs.
                </p>
                <p className="text-gray-400 text-lg leading-relaxed">
                  We aim to simplify digital marketing by combining creativity, automation, and innovation into one powerful application that anyone can use.
                </p>
                <p className="text-gray-300 text-lg font-semibold">
                  Edit Ezy envisions a future where every business—big or small—can create professional-quality promotional content in seconds and connect with customers more effectively.
                </p>
              </div>
            </div>
          )}
        </InView>

        {/* Right Section - Image */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 flex justify-center ${inView ? 'animate__animated animate__fadeInRight' : 'opacity-0'}`}
            >
              <img
                src="https://static.vecteezy.com/system/resources/previews/010/902/081/large_2x/business-analytics-in-cloud-arrow-leadership-company-people-challenge-teamwork-up-flat-job-marketing-concept-illustration-growth-with-rocket-investment-service-man-and-woman-trend-result-vector.jpg"
                alt="Our Vision"
                className="w-full max-w-xl h-auto object-cover rounded-2xl shadow-2xl shadow-purple-500/20"
              />
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default Vision;